// extracted by mini-css-extract-plugin
export default {"root":"empty-main_root__Ohoqc","section":"empty-main_section__Bkexl"};